import { DeleteContactOutDto, DeleteContactInDto } from '../../../types/contact.dto'

export const DELETE_CONTACT = 'DELETE_CONTACT'
export const DELETE_CONTACT_SUCCESS = 'DELETE_CONTACT_SUCCESS'
export const DELETE_CONTACT_ERROR = 'DELETE_CONTACT_ERROR'
export const RESET_DELETE_CONTACT = 'RESET_DELETE_CONTACT'


export interface DeleteContact {
  type: typeof DELETE_CONTACT
  payload: DeleteContactOutDto
}

export interface DeleteContactSuccess {
  type: typeof DELETE_CONTACT_SUCCESS
  payload: DeleteContactInDto
}

export interface DeleteContactError {
  type: typeof DELETE_CONTACT_ERROR
  payload: string | boolean
}

export interface ResetDeleteContact {
  type: typeof RESET_DELETE_CONTACT
  payload: null
}

export interface State {
  data: DeleteContactInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = DeleteContact | DeleteContactSuccess | DeleteContactError | ResetDeleteContact
